import { Injectable, ElementRef } from '@angular/core';
import { ToastrService, IndividualConfig } from 'ngx-toastr';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subject, Observable } from 'rxjs';
import { UserIdleService } from 'angular-user-idle';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  userActivity;
  userInactive: Subject<any> = new Subject();
  display: any;
  error: boolean = false;
  public readonly isProductionConfig: boolean = false;
  getLocalStorageData: any;
  public readonly paymentServeId: string = this.isProductionConfig ? '1373' : '1448';
  public readonly client_id: string = "8ac427ee-5bf1-4b98-8446-9a3932996b7f";
  public readonly client_secret: string = "qiW8Q~Cy_.K.DvlBQ9MXK6fDXCi-sKXz4BbTebYt";
  public readonly grant_type: string = "client_credentials";
  public readonly resource: string = "https://alforsanholding-uat.sandbox.operations.dynamics.com/";
  RetailAPIs = ["CreateSalesHeader", "PostOrder", "GetAccessToken", "CreateSalesHeader"];
  BANKPosAPIs = ["GetAuth", "GetTidMid", "SaveSettings", "Settle"];

  /***************** Development/UAT  Cerdential Start ********************/

  //public readonly paymentServeId: string = '1448';

  /***************** Development/UAT  Cerdential END ********************/

  /***************** Production  Cerdential Start ********************/

  //public readonly paymentServeId: string = '1373';

  /***************** Production  Cerdential END ********************/
  public Username = "AFUATKIOSK"; public Password = "AF@2023KIOSK";

  setTimeout() {
    this.userActivity = setTimeout(() => this.userInactive.next(undefined), 600000);
  }
  // default language
  public defaultSelectedUserLanguage = 'en';
  textDir: string;

  //Set Time to display pop up when user is idle for five minutes Abhijith 01-06-2023
  public timer = 1000 * 300;
  public timerset = 300;
  public username = "";
  // Text align direction
  public textAlignment = "ltr";

  public ChoosenLanguae = "ENG";

  public invoiceId: any;
  public showViewDetail: boolean = false;

  public timer2: any;
  // allow filetypes in Application
  public readonly allowedFileType: string = "png,jpg,jpeg,doc,docx,pdf";

  // allow file size in Application
  public readonly allowedFileSizeInMB: number = 5;

  // Used for reload the page
  isPageLoad: boolean = false;
  // Selected Language
  public prefLanguage = 'en';

  //For First time page load selected language
  isLanguageChanges: boolean = false;


  //For arabic language assigning value as 'an'
  public arabicLanguage = 'ar';

  // Used for Back to Search Fine Enquiry Page
  isBackToSearchFine: boolean = false;

  //Used for is Company Payment or not for Company List page
  isComapnyPayment: boolean = false;

  // To check Idle Time Started or not
  public isIdleTimeStarted: boolean = false;

  // Used for Back to Fine Enquiry Search field
  public isBackToFineEnquirySearch: boolean = false;

  // Used for show Add Driver button based on selected company payment status
  public showAddDriverBtn: boolean = false

  //Used to take equestrian/Livery reg data to payment screen
  public importRegistrationData: any;

  // Used for show Add Driver button based on selected company payment status
  public isCompanyTypeFranchise: boolean = false

  // Used for show Add Company button based on selected company Type
  public showAddCompanyBtn: boolean = false

  // Used for show Add Vehicle button based on selected company payment status
  public showAddVehicleBtn: boolean = false

  // Used for show validation on Add Vehicle/Driver button based on pending fine payment
  public showDriverVehicleAddBtnFineValidation: boolean = false

  // Used for show validation on Add Vehicle/Driver button based on company license number is '0' or not
  public showDriverVehicleAddBtnLicenseNumberValidation: boolean = false

  // Used for show validation on Add Vehicle/Driver button based on company Pending Fine
  public showDriverVehicleAddBtnPendingFineValidation: boolean = false

  // Used for show validation on Add Vehicle/Driver button based on company Expire
  public showDriverVehicleAddBtnCompanyExpireValidation: boolean = false

  // Used for show validation on Add Vehicle/Driver button based on company Pending payment
  public showDriverVehicleAddBtnPendingPaymentValidation: boolean = false

  // Used for assign company dashboard info
  public companyDashboardInfo: any = [];
  public assignCompanyDashInfo: boolean = false;

  //
  public isLoginCompanyList: boolean = false;

  // Email Pattern
  public readonly emailPattern: string = "[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[A-Za-z]{2,3}";

  // inputField Pattern
  public readonly inputFieldPattern: string = "([a-zA-Z0-9']+( [a-zA-Z0-9']+)*)";

  // Restrict Special Characters
  public readonly blockSpacialCherecter: string = "^[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z]+[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z0-9-_]*$";
  //"/^[^`~!@#$%\^&*()_+={}|[\]\\:';<>?,./1-9]*$/";
  cartDataArray = [];

  loginInfo = this.getValueFromSessionStorage('loginInfo');

  //Get_Auth method parameters settings for BANK POS integration, Abhijith 25-08-2023
  public VFI_TransType = "1";
  public VFI_ECRRcptNum = 1;
  public VFI_TID = "00299284";
  public VFI_OrgionalRcptNum = "1";

  constructor(
    private toastr: ToastrService,
    private httpClient: HttpClient,
    private userIdle: UserIdleService,
    private translate: TranslateService,
    private router: Router,
    private modalService: NgbModal,

  ) {
    this.startWatchingIdleTime();
    this.routerNavigationDetection();
  }

  getAgeByDOB(birthdate: Date): number {
    const today = new Date();
    let age = today.getFullYear() - birthdate.getFullYear();
    const monthDifference = today.getMonth() - birthdate.getMonth();
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthdate.getDate())) {
      age--;
    }
    return age;
  }

  //check if given date is equal to current date
  isSameDate(givenDateString: string): boolean {
    let currentDate = new Date();
    const [datePart, timePart] = givenDateString?.split(' ');
    const [day, month, year] = datePart?.split('-').map(Number);

    const givenDate = new Date(year, month - 1, day);

    return givenDate.getDate() === currentDate.getDate() &&
      givenDate.getMonth() === currentDate.getMonth() &&
      givenDate.getFullYear() === currentDate.getFullYear();
  }

  formatDateToDDMMYYYY(dateString: string): string {
    const date = new Date(dateString);

    // Extract the day, month, and year
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getUTCFullYear();

    // Format the date as "DD-MM-YYYY"
    return `${day}-${month}-${year}`;
  }

  generateGUID(): any {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  //Date format - Abhijith 24-05-2023
  // convertDateFormat(inputData) {
  //   if (inputData != null) {
  //     var date = inputData.getDate();
  //     var month = (inputData.getMonth() + 1);
  //     var convertedDate = inputData.getFullYear() + "-" + (month > 9 ? month : "0" + month) + "-" + (date > 9 ? date : "0" + date);
  //     return (convertedDate);
  //   } else {
  //     return inputData;
  //   }
  // }

  // for show toast message
  showToastMessage(message: string, messageType: number) {
    const obj: any = {
      closeButton: true,
      timeOut: 3000,
      progressBar: true,
      positionClass: 'toast-top-full-width'
    }
    if (messageType == 1) {
      this.toastr.success('', message, obj);
    } else {
      this.toastr.error('', message, obj);
    }
  }

  // get the Direction of word
  textDirection(selectedLanguage) {
    //var textAlignment = "";
    if (selectedLanguage == this.arabicLanguage) {
      this.textAlignment = 'rtl';
      this.prefLanguage = 'ar';
    }
    else {
      this.textAlignment = 'ltr';
      this.prefLanguage = 'en';
    }
    return this.textAlignment;
  }


  //Update an entry just as you would create a new one with setItem, but with a key that already exists:
  setValueToSessionStorage(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  //Read entries with sessionStorage.getItem:
  getValueFromSessionStorage(key) {
    try {
      return JSON.parse(sessionStorage.getItem(key));
    } catch (e) {
      console.error('Error getting data from localStorage', e, key);
      return null;
    }
  }

  formatDateToDDMMYYYYISOInputType(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
    const day = date.getDate().toString().padStart(2, '0');

    return `${day}-${month}-${year}`;
  }

  //Delete session storeage an entry with the removeItem method:
  deleteValueFromSessionStorage(key) {
    sessionStorage.removeItem(key)
  }

  //Update an entry just as you would create a new one with setItem, but with a key that already exists:

  calltimer(minute) {
    // let minute = 1;
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;
    const prefix = minute < 10 ? "0" : "";
    this.timer2 = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;
      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;
      this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      if (seconds == 0) {
        console.log("finished");
        clearInterval(this.timer2);
        //localStorage.clear();
        //sessionStorage.clear();
        this.modalService.dismissAll();
        this.router.navigateByUrl('/home/landing');
      } else {
        return;
      }
    }, 1000);
  }

  closeTimer() {
    clearInterval(this.timer2);
  }
  //Delete session storeage an entry with the removeItem method:
  deleteValueFromLocalStorage(key) {
    localStorage.removeItem(key)
  }

  // For isRequired form validation highlight the form control
  autoFocusOnErrorFieldInRecativeForm(recativeForm: FormGroup, el: ElementRef) {
    try {
      for (const key of Object.keys(recativeForm.controls)) {
        if (recativeForm.controls[key].invalid) {
          const invalidControl = el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
          if (invalidControl != null) {
            invalidControl.focus();
            break;
          }
        }
      }
    } catch (e) { console.log("Error ignore it ", e); }
  }

  // for calendar date formate to string
  calDateFormatToString(calDate: any): string {
    if (calDate == '' || calDate == null)
      return null
    try {
      let assigningDate = calDate.year + '-' + (calDate.month < 10 ? ('0' + calDate.month) : calDate.month)
        + '-' + (calDate.day < 10 ? ('0' + calDate.day) : calDate.day)
      return assigningDate;
    } catch (e) {
      return null;
    }
  }

  // for calendar date to string date
  calendarDateFormatToString(calDate: any): string {
    if (calDate == '' || calDate == null)
      return null
    try {
      let assigningDate = (calDate.day < 10 ? ('0' + calDate.day) : calDate.day) + '-' + (calDate.month < 10 ? ('0' + calDate.month) : calDate.month)
        + '-' + calDate.year
      return assigningDate;
    } catch (e) {
      return null;
    }
  }
  strintoUTCDate(stringDate: string): Date {
    if (stringDate == '' || stringDate == null) {
      return null
    }
    let array = stringDate.split("-");
    let newdate = '';
    if (array[0].length == 2) {
      newdate = stringDate.split("-").reverse().join("-");
    } else {
      newdate = stringDate;
    }
    let date = newdate.split("-")
    if (date.length == 3) {
      let year: number = parseInt(date[0]);
      let month: number = parseInt(date[1]) - 1;
      let day: number = parseInt(date[2]);
      var d = Date.UTC(year, month, day);
      return new Date(d);
    } else {
      return null
    }
  }

  // for convert string date to calendar date
  stringDateToCalDateFormat(stringDate: any): any {
    if (stringDate == '' || stringDate == null || stringDate == '0001-01-01T00:00:00')
      return null
    try {
      let array = stringDate.split("-");
      let newdate = '';
      if (array[0].length == 2) {
        newdate = stringDate.split("-").reverse().join("-");
      } else {
        newdate = stringDate;
      }
      let startdate = new Date(newdate);
      let dateStartFormat = { year: startdate.getFullYear(), month: startdate.getMonth() + 1, day: startdate.getDate() }
      return dateStartFormat;

    } catch (e) {
      return null;
    }
  }

  // For Select Min Date
  minimumDate: Date = new Date();
  minDate: Date = new Date(this.minimumDate.setDate(this.minimumDate.getDate() - 1));

  // for convert string date to calendar date for third party datepicker
  stringDateToCalendarDateFormat(stringDate: any): any {
    if (stringDate == '' || stringDate == null || stringDate == '0001-01-01T00:00:00')
      return null
    try {
      let array = stringDate.split("-");
      let newdate = '';
      if (array[0].length == 2) {
        newdate = stringDate.split("-").reverse().join("-");
      } else {
        newdate = stringDate;
      }
      let startdate = new Date(newdate);
      return startdate;

    } catch (e) {
      return null;
    }
  }

  //date format with dash in YYYY-MM-DD
  dateFields: any = [];
  dateFormatWithDash(inputDate) {
    if (inputDate != null) {
      var stringDate = inputDate.toLocaleString();
      this.dateFields = stringDate.split(" ");
      let totalDate = this.dateFields[0].replace(/,/, "");
      let totalDateSplit = totalDate.split('/');
      let month = parseInt(totalDateSplit[0]);
      let day = parseInt(totalDateSplit[1]);
      let formatDate = totalDateSplit[2] + "-" + (month > 9 ? month : "0" + month) + "-" + (day > 9 ? day : "0" + day);
      return (formatDate);
    } else {
      return inputDate;
    }
  }

  // for show toast message
  mesage: any = {};
  isOnSamePage: boolean = true;
  async showSussessFailureMessage(type: number, mesage: string, isOnSamePage: boolean = true, isI18Data: boolean = false) {
    this.isOnSamePage = isOnSamePage;
    this.mesage = {};
    this.mesage.showMessage = true;
    if (isI18Data) {
      this.mesage.mesage = await this.translate.get(mesage).toPromise();
    } else {
      this.mesage.mesage = mesage;
    }
    if (type == 1) {
      this.mesage.class = 'alert alert-success'
    } else {
      this.mesage.class = 'alert alert-danger'
    }
  }

  routerNavigationDetection() {
    //
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.isOnSamePage) {
          this.mesage = {};
        }
        this.isOnSamePage = true;
      }
    });
  }

  private siblingMsg = new Subject<any>();
  /*
   * @return {Observable<string>} : siblingMsg
   */
  public getContent(): Observable<any> {
    return this.siblingMsg.asObservable();
  }
  /*
   * @param {string} message : siblingMsg
   */
  public updateContent(message: any): void {
    this.siblingMsg.next(message);
  }

  private companyList = new Subject<any>();
  /*
   * @return {Observable<string>} : companyList
   */
  public getCompanyListContent(): Observable<any> {
    return this.companyList.asObservable();
  }
  /*
   * @param {string} message : companyList
   */
  public updateCompanyListContent(message: any): void {
    this.companyList.next(message);
  }

  public signatures = {
    JVBERi0: "application/pdf",
    R0lGODdh: "image/gif",
    R0lGODlh: "image/gif",
    iVBORw0KGgo: "image/png",
    AAQSkZJRgA: "image/jpeg",
    UEsDBBQABgA: "application/octet-stream"
  };

  detectMimeType(b64) {
    for (let s in this.signatures) {
      if (b64.indexOf(s) === 0) {
        return this.signatures[s];
      }
    }
  }
  convertBase64ToBlobData(base64Data: string, contentType: string, sliceSize = 512) {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  // For download file
  //downloadFile(json: any) {
  //  if (json.Data) {
  //    let fileData = json.Data.split('base64,');
  //    if (fileData.length > 1) {
  //      json.Data = fileData[1];
  //    } else {
  //      json.Data = json.Data;
  //    }
  //    const contentType = this.detectMimeType(json.Data)
  //    const blobData = this.convertBase64ToBlobData(json.Data, contentType);
  //    if (window.navigator && window.navigator.msSaveOrOpenBlob) { //IE
  //      window.navigator.msSaveOrOpenBlob(blobData, json.FileName);
  //    } else { // chrome
  //      const blob = new Blob([blobData], { type: contentType });
  //      const url = window.URL.createObjectURL(blob);
  //      const link = document.createElement('a');
  //      link.href = url;
  //      link.download = json.FileName;
  //      link.click();
  //    }
  //  }
  //}

  // Check login Info & Session
  async isUserLoggedIn() {
    //
    if (this.getValueFromSessionStorage('loginInfo') == null) {
      //localStorage.clear();
      sessionStorage.clear();
      this.router.navigateByUrl('/home/customer_executive_login');
    } else {
      this.restartIdleTime();
    }
  }


  // This method is used to perform action once it is Idle
  idleTimeActionPerform() {
    //
    // Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe(count => console.log(count));

    // Start watch when time is up.
    this.userIdle.onTimeout().subscribe(() => {
      let now = new Date();
      //console.log("Over time = ", now)
      if (this.getValueFromSessionStorage('loginInfo') != null) {
        let userLoginInfo = this.getValueFromSessionStorage('loginInfo');
        let jsonData: any = {};
        let outerJsonData: any = {};
        jsonData.UserID = userLoginInfo.ID;
        jsonData.EmiratesID = userLoginInfo.EmiratesID;
        outerJsonData.inputParameter = JSON.stringify(jsonData);
        this.logOutAPICall(outerJsonData);
      }
    });
  }

  // For Logout
  async logOutAPICall(formData: any, hideLoader: boolean = true): Promise<any> {
    //
    this.httpClient.post("api/LoginManager/Logout", formData).subscribe(res => {
      sessionStorage.clear();
      this.stopWatchingIdleTime();
    }, err => {
      console.log(err);
    }
    );
  }
  // End logout

  // This Method is used to start Wathcing idle Time
  startWatchingIdleTime() {
    //
    //console.log("Timer Started..")
    let now = new Date();
    //console.log("Started time = ", now)
    if (!this.isIdleTimeStarted && this.getValueFromSessionStorage('userLoginInfo') != null) {
      //Start watching for user inactivity
      this.userIdle.startWatching();
      this.isIdleTimeStarted = true;
      this.idleTimeActionPerform();
    }
  }

  // This Method is used to Stop Wathcing idle Time
  async stopWatchingIdleTime() {
    //
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('confirm_dia_modal');
    this.userIdle.stopWatching();
    this.isIdleTimeStarted = false;

    const WantDetete = await this.translate.get('SessionExpire').toPromise();
    const OK = await this.translate.get('OK').toPromise();
    //// this.confirmationDialogService.confirm('', WantDetete, OK, '')
    //   .then((confirmed) => {
    //     let now = new Date();
    //     //console.log("Over time after confirm = ", now)
    //     this.modalService.dismissAll();
    //     //localStorage.clear();
    //     sessionStorage.clear();
    //     this.textDir = this.textDirection('en');
    //     this.router.navigate(['/home/customer_executive_login']);
    //   });
  }

  // This Method is used to Reset  idle Time
  restartIdleTime() {
    this.userIdle.resetTimer();
  }

  //Checking only special characters
  special_char(event) {
    /*var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));*/

    let blockedCharArray = [123, 124, 125, 126, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 45, 47, 58, 59, 60, 61, 62, 63, 64, 91, 92, 93, 94, 95, 96]
    let k = event.charCode;
    //console.log(k);
    if (blockedCharArray.indexOf(k) > -1) {
      return false;
    }
    return true;
  }


  // Not allowing some special character
  /*allow_some_special_char(event) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || k == 45 || k == 47 || (k >= 48 && k <= 57));
  }*/

  // allow alphanmeric keywords
  allow_alphanumeric(event) {
    //console.log("hello3");
    let blockedCharArray = [123, 124, 125, 126, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 45, 47, 58, 59, 60, 61, 62, 63, 64, 91, 92, 93, 94, 95, 96]
    let k = event.charCode;
    //console.log(k);
    if (blockedCharArray.indexOf(k) > -1) {
      return false;
    }
    //var flag = (k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57);

    //console.log("flag :: ", flag);
    return true;
  }

  // allow only number
  allow_numeric(event) {
    let k;
    k = event.charCode;
    return ((k >= 48 && k <= 57));
  }

  // allow only alphabets
  allow_alphabet(event) {
    /* var k;
     k = event.charCode;
     return ((k >= 97 && k <= 122) || k == 8 || k == 32 || (k >= 65 && k <= 90));*/

    let blockedCharArray = [123, 124, 125, 126, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 45, 47, 58,
      59, 60, 61, 62, 63, 64, 91, 92, 93, 94, 95, 96, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 46]
    let k = event.charCode;
    //console.log(k);
    if (blockedCharArray.indexOf(k) > -1) {
      return false;
    }
    //var flag = (k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57);

    //console.log("flag :: ", flag);
    return true;
  }

  // allow character for website
  allow_special_character_for_website(event) {
    let k;
    k = event.charCode;
    return ((k >= 97 && k <= 122) || k == 8 || k == 32 || k == 46 || (k >= 65 && k <= 90) || (k >= 48 && k <= 57));
  }

  // Only AlphaNumeric
  keyPressAlphaNumeric(event) {

    let inp = String.fromCharCode(event.keyCode);

    if (/[a-zA-Z0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }


  // this method is used to check permission for action in individual Page
  checkPermission(permissionCode: string): boolean {
    // get Login Info
    let loginInfo = this.getValueFromSessionStorage('loginInfo');
    if (loginInfo != null && loginInfo.featureIdList != null) {
      loginInfo = loginInfo.featureIdList.replace(/ /g, '');
      if (loginInfo.endsWith(',')) {
        loginInfo = loginInfo.substring(0, loginInfo.length - 1);
      }
      let perArray = loginInfo.split(",");
      if (perArray.lastIndexOf(permissionCode) >= 0) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  // All Role Permission Code
  public readonly permission: any = {
    "EREGISTRATION": {
      CREATE_REGISTRATION: "CREATE_REGISTRATION",
      UPDATE_REGISTRATION: "UPDATE_REGISTRATION",
      DELETE_REGISTRATION: "DELETE_REGISTRATION",
      LIST_REGISTRATION: "LIST_REGISTRATION",
      HORSE_ASSIGNMENT: "HORSE_ASSIGNMENT"
    }, "EMASTER": {
      CREATE_MASTER: "CREATE_MASTER",
      UPDATE_MASTER: "UPDATE_MASTER",
      DELETE_MASTER: "DELETE_MASTER"
    }, "LIVERY": {
      UPDATE_REGISTRATION: "UPDATE_REGISTRATION",
      DELETE_REGISTRATION: "DELETE_REGISTRATION"
    },
    "USER_MAGEMENT": {
      "USER": {
        CREATE_USER: 'CREATE_USER',
        UPDATE_USER: 'UPDATE_USER',
        DELETE_USER: 'DELETE_USER',
        LIST_USER: 'LIST_USER'
      },
      "ROLE": {
        CREATE_ROLE: 'CREATE_ROLE',
        UPDATE_ROLE: 'UPDATE_ROLE',
        DELETE_ROLE: 'DELETE_ROLE',
        LIST_ROLE: 'LIST_ROLE'
      },
      "ROLEPERMISSION": {
        LIST_ROLEPERMISSION: 'PERMISSION_LIT'
      }
    },
    "CUSTOMERS": {
      LIST_CUSTOMERS: 'LIST_CUSTOMERS',
      CREATE_CUSTOMERS: 'CREATE_CUSTOMERS',
      UPDATE_CUSTOMERS: 'UPDATE_CUSTOMERS',
    },
    "ACTIVITY": {
      LIST_ACTIVITY: 'LIST_ACTIVITY',
      BOOK_ACTIVITY: 'BOOK_ACTIVITY',
      CHECK_IN: 'CHECK_IN',
      ADDITIONAL_DETAILS: 'ADDITIONAL_DETAILS'
    },
    "MEMBERSHIP": {
      BOOK_MEMBERSHIP: 'BOOK_MEMBERSHIP',
      LIST_BOOK_MEMBERSHIP: 'LIST_BOOK_MEMBERSHIP'
    },
    "INVOICE": {
      LIST_INVOICE: 'LIST_INVOICE',
      PRINT_INVOICE: 'PRINT_INVOICE'
    },
    "DISCOUNT": {
      LIST_DISCOUNT: 'LIST_DISCOUNT',
      VIEW_DISCOUNT: 'VIEW_DISCOUNT'
    },
    "EVENTS": {
      LIST_EVENTS: 'LIST_EVENTS',
      VIEW_EVENTS: 'VIEW_EVENTS'
    },
    "EPAYMENTS": {
      PAYMENT: 'PAYMENT'
    },
    "REPORTS": {
      CASHIER_REPORT: 'CASHIER_REPORT',
      SALES_REPORT: 'SALES_REPORT',
      CASHIER_FILTERS: 'CASHIER_FILTERS',
      NPAX_REPORT: 'NPAX_REPORT',
      SALES_LINE_REPORT: 'SALES_LINE_REPORT',
      SALES_ORDER_REPORT : 'SALES_ORDER_REPORT'
    }
  }

  // Digit Pattern
  numberpattern = "[0-9]*";

  // Method is user to check whether variable is object or Not
  isObject(obj) {
    return obj !== undefined && obj !== null && obj.constructor == Object;
  }

  // this method is used to check permission for main group & sub group in Header page Only
  mainOrSubGroupCheckPermission(mainGroupName, subGroupName): boolean {
    // get Login Info
    let loginInfo = this.getValueFromSessionStorage('loginInfo');
    let outerJson = subGroupName == '' ? this.permission[mainGroupName] : this.permission[mainGroupName][subGroupName]
    if (this.isObject(outerJson)) {
      for (let inner in outerJson) {
        let innerJson = outerJson[inner];
        if (this.isObject(innerJson)) {
          for (let action in innerJson) {
            let actionJson = innerJson[action];
            let per = this.checkPermission(actionJson)
            if (per) {
              return per;
            }
          }
        } else {
          let per = this.checkPermission(innerJson)
          if (per) {
            return per;
          }
        }
      }
    }
    return false;
  }


  createGroupSubGroupForm(result: any[], mainProperty: string, subProperity: string = ''): any[] {
    const mainGroupedCollection = result.reduce((previous, current) => {
      if (!previous[current[mainProperty]]) {
        previous[current[mainProperty]] = [current];
      } else {
        previous[current[mainProperty]].push(current);
      }
      return previous;
    }, {});
    return Object.keys(mainGroupedCollection).map(key => (
      {
        key: key,
        keyName: mainGroupedCollection[key].length > 0 ? mainGroupedCollection[key][0][subProperity] ? mainGroupedCollection[key][0][subProperity] : null : null,
        value: mainGroupedCollection[key],
      }
    ));
  }

  mapAndJoinWithComma(arr, key) {
    if (arr == '' || arr == null)
      return '';
    return arr.map(function (o) {
      return o[key];
    }).join();
  }

  // allow only number
  allowNumeric(event) {
    let k;
    k = event.charCode;
    console.log(k);
    return ((k >= 48 && k <= 57) || k == 45 || k == 46);
  }

  //Update an entry just as you would create a new one with setItem, but with a key that already exists:
  setValueToLocalStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  //Read entries with localStorage.getItem:
  getValueFromLocalStorage(key) {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch (e) {
      console.error('Error getting data from localStorage', e);
      return null;
    }
  }


  showHideLinkByStsId(stausId, moduleName): boolean {
    let flag: boolean = false;
    switch (moduleName) {
      //case 'RevCRAnlPlan':
      //  flag = ![this.planGeneratedStatusId, this.approvedStatusId, this.archivedStatusId].includes(stausId);
      //  break;
      //case 'RevMonthList':
      //  flag = [this.approvedStatusId, this.archivedStatusId].includes(stausId);
      //  break;
      //case 'RevCRMonthP':
      //  flag = [this.approvedStatusId].includes(stausId);
      //  break;
      //case 'RevAnlClone':
      //  flag = [this.planGeneratedStatusId, this.approvedStatusId, this.archivedStatusId].includes(stausId);
      //  break;
      //case 'RevCRModel':
      //  flag = ![this.planGeneratedStatusId, this.approvedStatusId, this.archivedStatusId].includes(stausId);
      //  break;
      //case 'RevGenCashPln':
      //  flag = ![this.planGeneratedStatusId, this.approvedStatusId, this.archivedStatusId].includes(stausId);
      //  break;
      //case 'RevSaveForecast':
      //  flag = ![this.planGeneratedStatusId, this.approvedStatusId, this.archivedStatusId].includes(stausId);
      //  break;
      //case 'RevTransAdj':
      //  flag = ![this.planGeneratedStatusId, this.approvedStatusId, this.archivedStatusId].includes(stausId);
      //  break;


      //case 'ExpMonthList':
      //  flag = [this.approvedStatusId, this.archivedStatusId].includes(stausId);
      //  break;
      //case 'ExpCRMonthP':
      //  flag = [this.approvedStatusId].includes(stausId);
      //  break;
      //case 'ExpCRAnlPlan':
      //  flag = ![this.planGeneratedStatusId, this.approvedStatusId, this.archivedStatusId].includes(stausId);
      //  break;
      //case 'ExpCRModel':
      //  flag = ![this.planGeneratedStatusId, this.approvedStatusId, this.archivedStatusId].includes(stausId);
      //  break;
      //case 'ExpGenCashPln':
      //  flag = ![this.planGeneratedStatusId, this.approvedStatusId, this.archivedStatusId].includes(stausId);
      //  break;
      //case 'ExpSaveForecast':
      //  flag = ![this.planGeneratedStatusId, this.approvedStatusId, this.archivedStatusId].includes(stausId);
      //  break;

      //default:
      //  break;
    }

    return flag;


  }
  private readonly sercatKey: string = "8080808080808080";
  encrypt(planText: string): string {
    let _key = CryptoJS.enc.Utf8.parse(this.sercatKey);
    let _iv = CryptoJS.enc.Utf8.parse(this.sercatKey);
    let encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(planText), _key, {
      keySize: 128 / 8,
      iv: _iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  }
  decryptUsingAES256(encryptedText: string): string {
    let _key = CryptoJS.enc.Utf8.parse(this.sercatKey);
    let _iv = CryptoJS.enc.Utf8.parse(this.sercatKey);

    let decrypted = CryptoJS.AES.decrypt(
      encryptedText, _key, {
      keySize: 128 / 8,
      iv: _iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);
    return decrypted;
  }

  disclaimerHead = "In consideration of being permitted to participate in an activity or activities offered by AL FORSAN INTERNATIONAL SPORTS RESORT LLC(AL FORSAN)(including, but not limited to, Archery, Equestrian, Paintball, Watersports, Shooting and Motorsports)(each an Activity and together the Activities), I acknowledge, appreciate and agree that:"
  //"In consideration of being permitted to\
  //participate in an activity or activities offered\
  //by AL FORSAN INTERNATIONAL\
  //SPORTS RESORT LLC (AL FORSAN)\
  //(including, but not limited to, Archery,\
  //Equestrian, Paintball, Watersports,\
  //Shooting, and Motorsports) (each an\
  //Activity and together the Activities), I\
  //acknowledge, appreciate and agree that: "

  disclaimerOne = "1.	There is a significant risk of injury from the Activities and or the weaponry or equipment used in the Activities and that there is significant risk including the risk of disability or death. If instructions as to use of the equipment and participation in the Activities is followed, then the Activities can be safely undertaken and enjoyed.  Therefore, I acknowledge that whilst the organizers have taken every precaution and the use of protective equipment will minimize this risk, the risk of serious injury or death does exist"
  //"1. There is a significant risk of injury from the Activities and or the weaponry or equipment used in the Activities and that\
  //there is significant risk including the risk of disability or death. If instructions as to use of the equipment and\
  //participation in the Activities is followed, then the Activities can be safely undertaken and enjoyed. Therefore, I acknowledge that whilst the\
  //organizers have taken every precaution and the use of protective equipment will minimize this risk, the risk of serious injury or death does exist "

  disclaimerTwo = "2.	I knowingly and freely assume all such risks from any and all Activities, both known and unknown and assume responsibility for my participation except for any loss, liability,\
damage or cost caused by the negligence, gross negligence or willful misconduct of those persons released from liability below and defined as the  Releasees."
  //"2. I knowingly and freely assume all such risks from any and all Activities, both known and unknown and assume\
  //responsibility for my participation except for any loss, liability, damage or cost caused by the negligence, gross\
  //negligence or willful misconduct of those persons released from liability below and defined as the Releasees. "

  disclaimerThree = "3.	I understand that all the Activities are or can be physically and mentally demanding.\
I hereby acknowledge and confirm that I am physically fit and do not suffer from any medical condition which may affect my ability to participate in the Activity or Activities safely."
  //"3. I understand that all the Activities are or can be physically and mentally demanding. I hereby acknowledge and\
  //confirm that I am physically fit and do not suffer from any medical condition which may affect my ability to participate in the\
  //Activity or Activities safely. "

  disclaimerFour = "4. I confirm and acknowledge that I have received all appropriate training and instruction. I further confirm that I have read the rules and will obey the same at all times.\
I fully understand the rules of the chosen Activities and will comply with all rules and regulations. If I observe any unusual or unnecessary hazard during my participation, I will bring such to the attention of the nearest official as soon as practical."
  //"4. I confirm and acknowledge that I have received all appropriate training and instruction. I further confirm that I have\
  //read the rules and will obey the same at all times. I fully understand the rules of the chosen Activities and will comply with all\
  //rules and regulations. If I observe any unusual or unnecessary hazard during my participation, I will bring such to the\
  //attention of the nearest official as soon as practical.  "

  disclaimerFive = "5. I understand that in the event of a medical emergency where the removal of clothing is necessary for the administration of medical treatment, including but not limited to CPR,\
defibrillation, or first aid, the resort staff may need to remove clothing for the well-being of my child. I hereby waive any claims or liabilities during such medical treatment."
  //"5. I, for myself and on behalf on my heirs, personal representatives and next of kin, release and forever discharge and\
  //covenant agree not to sue AL FORSAN, its related companies, , the owners, its staff, employees, officers, agents, insurers and equipment suppliers\
  //(“Releasees”), with respect to any liability for any injury, disability, death, to me that may occur during the Activities except where such injury,\
  //disability, death or any other non specified damages are caused by the negligence, gross negligence or willful misconduct of any of the Releasees. "

  disclaimerSix = "6. I, for myself and on behalf on my heirs, personal representatives and next of kin, release and forever discharge and covenant agree not to sue AL FORSAN, its related companies, , the owners, its staff, employees, officers, agents,\
insurers and equipment suppliers (“Releases”), with respect to any liability for any injury, disability, death, to me that may occur during the Activities except where such injury, disability, death or any other non-specified damages are caused by the negligence, gross negligence or willful misconduct of any of the Releases."
  //"6. I agree to indemnify and hold harmless the Releasees and each of them from any loss, liability, damage, or cost they may\
  //incur arising out of or related to the Activities if caused by negligence, gross negligence or willful misconduct of myself, my heirs, or my personal\
  //representatives and next of kin.. "

  disclaimerSeven = "7. I, the undersigned parent/guardian, grant permission for photos and videos of my child, and me to be taken during their participation in resort activities.\
I understand that these images / videos may be used for promotional or marketing purposes by the resort."
  //"7. I understand and agree that this Release of Liability Agreement covers each and every occasion on which I participate in\
  //an Activity or any of the Activities in which I participate hereafter at AL FORSAN I or elsewhere where the Activities are organized by ALFORSAN"

  disclaimerEight = "8. I agree to indemnify and hold harmless the Releases and each of them from any loss, liability, damage,\
or cost they may incur arising out of or related to the Activities if caused by negligence, gross negligence or willful misconduct of myself, my heirs, or my personal representatives and next of kin.."
  //"8. I understand that I am fully liable and responsible for all the equipment issued/rented to me. I further understand\
  //that I will be held financially responsible to AL FORSAN for the loss or damage of any such rented/issued/ rented equipment "

  disclaimerNine = "9. I understand and agree that this Release of Liability Agreement covers each and every occasion on which I participate in an Activity or any of the Activities in which I participate hereafter at AL FORSAN I or elsewhere where the Activities are organized by AL FORSAN."
  //"9. Further, I understand that I am personally responsible for any personal equipment that I might use and guarantee that all\
  //my personal equipment complies with standard safety regulations followed by AL FORSAN and any relevant recognized g"

  disclaimerTen = "10. I understand that I am fully liable and responsible for all the equipment issued/rented to me. I further understand that I will be held financially responsible to AL FORSAN for the loss or damage of any such rented/issued/ rented equipment."

  disclaimerEleven = "11. Further, I understand that I am personally responsible for any personal equipment that I might use and guarantee that all my personal equipment complies with standard safety regulations followed by AL FORSAN and any relevant recognized governing body of each respective"
  disclaimertwelve = "12. Are you able to swim?"
  disclaimerTweveYes = "Yes"
  disclaimerTweveNO = "No"
  disclaimerThirteen = "If you answered No, please be aware that you must comply with the swimming guardian's instructions."

  disclaimerHeadTwo = "I HAVE READ AND FULLY UNDERSTAND THIS RELEASE OF LIABILITY AND ASSUMPTION OF RISK AGREEMENT, AND UNDERSTANDING ITS TERMS, UNDERSTAND THAT I HAVE GIVEN UP SUBSTANTIAL RIGHTS BY SIGNING IT FREELY AND VOLUNTARILY WITHOUT INDUCEMENT AND THE LEGAL EFFECT OF IT."
  //"I HAVE READ AND FULLY UNDERSTAND THIS RELEASE OF LIABILITY AND ASSUMPTION OF RISK AGREEMENT, AND UNDERSTANDING ITS\
  //TERMS, UNDERSTAND THAT I HAVE GIVEN UP SUBSTANTIAL RIGHTS BY SIGNING IT REELY AND VOLUNTARILY WITHOUT INDUCEMENT AND THE LEGAL EFFECT OF IT"

  disclaimerSwimming = "Swimming is mandatory for water sports accepting this document we will consider you know swimming. "

  timeslotBatch = [
    {
      Id: "01",
      BatchCategoryName: "10-12 AM",
      StartTime: "10:00",
      EndTime: "12:00",
      IsSelected: false,
      IsAvailableInCart: false,
      selectedTimeSlots: []
    },
    {
      Id: "02",
      BatchCategoryName: "12-03 PM",
      StartTime: "12:00",
      EndTime: "15:00",
      IsSelected: false,
      IsAvailableInCart: false,
      selectedTimeSlots: []
    },
    {
      Id: "03",
      BatchCategoryName: "03-06 PM",
      StartTime: "15:00",
      EndTime: "18:00",
      IsSelected: false,
      IsAvailableInCart: false,
      selectedTimeSlots: []
    },
    {
      Id: "04",
      BatchCategoryName: "06-09 PM",
      StartTime: "18:00",
      EndTime: "21:00",
      IsSelected: false,
      IsAvailableInCart: false,
      selectedTimeSlots: []
    },
    {
      Id: "05",
      BatchCategoryName: "09-11 PM",
      StartTime: "21:00",
      EndTime: "23:00",
      IsSelected: false,
      IsAvailableInCart: false,
      selectedTimeSlots: []
    }
  ]
  //All mandatory changes should be based on selected store level, Abhijith 16-12-2024
  StoreContainsMandatoryPermissions = [
    {
      ChannelId: 'SHOT',
      StoreName: "Shooting"
    }
  ]

  //If user selected store exists in the array then only mandatory option should apply, Abhijith 16-12-2024
  checkPermissionForMandaoryFields(): boolean {
    let loginInfoData = this.getValueFromSessionStorage('loginInfo');
    let result = false;
    let findele = this.StoreContainsMandatoryPermissions.find(ele => ele.ChannelId == loginInfoData.ChannelId);
    if (findele != undefined && findele != null)
      return result = true;
  }

  CountryList =
    [
      { "NID": "N-233", "Nationality": "United Arab Emirates", "CountryCode": "AE", "DialNumber": "+971" },
    { "NID": "N-1", "Nationality": "Afghanistan", "CountryCode": "AF", "DialNumber": "+93" },
    { "NID": "N-2", "Nationality": "Aland Islands", "CountryCode": "AX", "DialNumber": "+358" },
    { "NID": "N-3", "Nationality": "Albania", "CountryCode": "AL", "DialNumber": "+355" },
    { "NID": "N-4", "Nationality": "Algeria", "CountryCode": "DZ", "DialNumber": "+213" },
    { "NID": "N-5", "Nationality": "American Samoa", "CountryCode": "AS", "DialNumber": "+1-684" },
    { "NID": "N-6", "Nationality": "Andorra", "CountryCode": "AD", "DialNumber": "+376" },
    { "NID": "N-7", "Nationality": "Angola", "CountryCode": "AO", "DialNumber": "+244" },
    { "NID": "N-8", "Nationality": "Anguilla", "CountryCode": "AI", "DialNumber": "+1-264" },
    { "NID": "N-9", "Nationality": "Antarctica", "CountryCode": "AQ", "DialNumber": "+672" },
    { "NID": "N-10", "Nationality": "Antigua and Barbuda", "CountryCode": "AG", "DialNumber": "+1-268" },
    { "NID": "N-11", "Nationality": "Argentina", "CountryCode": "AR", "DialNumber": "+54" },
    { "NID": "N-12", "Nationality": "Armenia", "CountryCode": "AM", "DialNumber": "+374" },
    { "NID": "N-13", "Nationality": "Aruba", "CountryCode": "AW", "DialNumber": "+297" },
    { "NID": "N-14", "Nationality": "Australia", "CountryCode": "AU", "DialNumber": "+61" },
    { "NID": "N-15", "Nationality": "Austria", "CountryCode": "AT", "DialNumber": "+43" },
    { "NID": "N-16", "Nationality": "Azerbaijan", "CountryCode": "AZ", "DialNumber": "+994" },
    { "NID": "N-17", "Nationality": "Bahamas", "CountryCode": "BS", "DialNumber": "+1-242" },
    { "NID": "N-18", "Nationality": "Bahrain", "CountryCode": "BH", "DialNumber": "+973" },
    { "NID": "N-19", "Nationality": "Bangladesh", "CountryCode": "BD", "DialNumber": "+880" },
    { "NID": "N-20", "Nationality": "Barbados", "CountryCode": "BB", "DialNumber": "+1-246" },
    { "NID": "N-21", "Nationality": "Belarus", "CountryCode": "BY", "DialNumber": "+375" },
    { "NID": "N-22", "Nationality": "Belgium", "CountryCode": "BE", "DialNumber": "+32" },
    { "NID": "N-23", "Nationality": "Belize", "CountryCode": "BZ", "DialNumber": "+501" },
    { "NID": "N-24", "Nationality": "Benin", "CountryCode": "BJ", "DialNumber": "+229" },
    { "NID": "N-25", "Nationality": "Bermuda", "CountryCode": "BM", "DialNumber": "+1-441" },
    { "NID": "N-26", "Nationality": "Bhutan", "CountryCode": "BT", "DialNumber": "+975" },
    { "NID": "N-27", "Nationality": "Bolivia", "CountryCode": "BO", "DialNumber": "+591" },
    { "NID": "N-28", "Nationality": "Bonaire", "CountryCode": "BQ", "DialNumber": "+599" },
    { "NID": "N-29", "Nationality": "Bosnia and Herzegovina", "CountryCode": "BA", "DialNumber": "+387" },
    { "NID": "N-30", "Nationality": "Botswana", "CountryCode": "BW", "DialNumber": "+267" },
    { "NID": "N-31", "Nationality": "Bouvet Island", "CountryCode": "BV", "DialNumber": "+47" },
    { "NID": "N-32", "Nationality": "Brazil", "CountryCode": "BR", "DialNumber": "+55" },
    { "NID": "N-33", "Nationality": "British Indian Ocean Territory", "CountryCode": "IO", "DialNumber": "+246" },
    { "NID": "N-34", "Nationality": "Brunei Darussalam", "CountryCode": "BN", "DialNumber": "+673" },
    { "NID": "N-35", "Nationality": "Bulgaria", "CountryCode": "BG", "DialNumber": "+359" },
    { "NID": "N-36", "Nationality": "Burkina Faso", "CountryCode": "BF", "DialNumber": "+226" },
    { "NID": "N-37", "Nationality": "Burundi", "CountryCode": "BI", "DialNumber": "+257" },
    { "NID": "N-38", "Nationality": "Cambodia", "CountryCode": "KH", "DialNumber": "+855" },
    { "NID": "N-39", "Nationality": "Cameroon", "CountryCode": "CM", "DialNumber": "+237" },
    { "NID": "N-40", "Nationality": "Canada", "CountryCode": "CA", "DialNumber": "+1" },
    { "NID": "N-41", "Nationality": "Cape Verde", "CountryCode": "CV", "DialNumber": "+238" },
    { "NID": "N-42", "Nationality": "Cayman Islands", "CountryCode": "KY", "DialNumber": "+1-345" },
    { "NID": "N-43", "Nationality": "Central African Republic", "CountryCode": "CF", "DialNumber": "+236" },
    { "NID": "N-44", "Nationality": "Chad", "CountryCode": "TD", "DialNumber": "+235" },
    { "NID": "N-45", "Nationality": "Chile", "CountryCode": "CL", "DialNumber": "+56" },
    { "NID": "N-46", "Nationality": "China", "CountryCode": "CN", "DialNumber": "+86" },
    { "NID": "N-47", "Nationality": "Christmas Island", "CountryCode": "CX", "DialNumber": "+61" },
    { "NID": "N-48", "Nationality": "Cocos (Keeling) Islands", "CountryCode": "CC", "DialNumber": "+61" },
    { "NID": "N-49", "Nationality": "Colombia", "CountryCode": "CO", "DialNumber": "+57" },
      { "NID": "N-50", "Nationality": "Comoros", "CountryCode": "KM", "DialNumber": "+269" },
        { "NID": "N-51", "Nationality": "Congo", "CountryCode": "CG", "DialNumber": "+242" },
        { "NID": "N-52", "Nationality": "Cook Islands", "CountryCode": "CK", "DialNumber": "+682" },
        { "NID": "N-53", "Nationality": "Costa Rica", "CountryCode": "CR", "DialNumber": "+506" },
        { "NID": "N-54", "Nationality": "Côte d'Ivoire", "CountryCode": "CI", "DialNumber": "+225" },
        { "NID": "N-55", "Nationality": "Croatia", "CountryCode": "HR", "DialNumber": "+385" },
        { "NID": "N-56", "Nationality": "Cuba", "CountryCode": "CU", "DialNumber": "+53" },
        { "NID": "N-57", "Nationality": "Curaçao", "CountryCode": "CW", "DialNumber": "+599" },
        { "NID": "N-58", "Nationality": "Cyprus", "CountryCode": "CY", "DialNumber": "+357" },
        { "NID": "N-59", "Nationality": "Czech Republic", "CountryCode": "CZ", "DialNumber": "+420" },
        { "NID": "N-60", "Nationality": "Democratic Republic of the Congo", "CountryCode": "CD", "DialNumber": "+243" },
        { "NID": "N-61", "Nationality": "Denmark", "CountryCode": "DK", "DialNumber": "+45" },
        { "NID": "N-62", "Nationality": "Djibouti", "CountryCode": "DJ", "DialNumber": "+253" },
        { "NID": "N-63", "Nationality": "Dominica", "CountryCode": "DM", "DialNumber": "+1-767" },
        { "NID": "N-64", "Nationality": "Dominican Republic", "CountryCode": "DO", "DialNumber": "+1-809" },
        { "NID": "N-65", "Nationality": "Ecuador", "CountryCode": "EC", "DialNumber": "+593" },
        { "NID": "N-66", "Nationality": "Egypt", "CountryCode": "EG", "DialNumber": "+20" },
        { "NID": "N-67", "Nationality": "El Salvador", "CountryCode": "SV", "DialNumber": "+503" },
        { "NID": "N-68", "Nationality": "Equatorial Guinea", "CountryCode": "GQ", "DialNumber": "+240" },
        { "NID": "N-69", "Nationality": "Eritrea", "CountryCode": "ER", "DialNumber": "+291" },
        { "NID": "N-70", "Nationality": "Estonia", "CountryCode": "EE", "DialNumber": "+372" },
        { "NID": "N-71", "Nationality": "Ethiopia", "CountryCode": "ET", "DialNumber": "+251" },
        { "NID": "N-72", "Nationality": "Falkland Islands (Malvinas)", "CountryCode": "FK", "DialNumber": "+500" },
        { "NID": "N-73", "Nationality": "Faroe Islands", "CountryCode": "FO", "DialNumber": "+298" },
        { "NID": "N-74", "Nationality": "Fiji", "CountryCode": "FJ", "DialNumber": "+679" },
        { "NID": "N-75", "Nationality": "Finland", "CountryCode": "FI", "DialNumber": "+358" },
        { "NID": "N-76", "Nationality": "France", "CountryCode": "FR", "DialNumber": "+33" },
        { "NID": "N-77", "Nationality": "French Guiana", "CountryCode": "GF", "DialNumber": "+594" },
        { "NID": "N-78", "Nationality": "French Polynesia", "CountryCode": "PF", "DialNumber": "+689" },
        { "NID": "N-79", "Nationality": "French Southern Territories", "CountryCode": "TF", "DialNumber": "+262" },
        { "NID": "N-80", "Nationality": "Gabon", "CountryCode": "GA", "DialNumber": "+241" },
        { "NID": "N-81", "Nationality": "Gambia", "CountryCode": "GM", "DialNumber": "+220" },
        { "NID": "N-82", "Nationality": "Georgia", "CountryCode": "GE", "DialNumber": "+995" },
        { "NID": "N-83", "Nationality": "Germany", "CountryCode": "DE", "DialNumber": "+49" },
        { "NID": "N-84", "Nationality": "Ghana", "CountryCode": "GH", "DialNumber": "+233" },
        { "NID": "N-85", "Nationality": "Gibraltar", "CountryCode": "GI", "DialNumber": "+350" },
        { "NID": "N-86", "Nationality": "Greece", "CountryCode": "GR", "DialNumber": "+30" },
        { "NID": "N-87", "Nationality": "Greenland", "CountryCode": "GL", "DialNumber": "+299" },
        { "NID": "N-88", "Nationality": "Grenada", "CountryCode": "GD", "DialNumber": "+1-473" },
        { "NID": "N-89", "Nationality": "Guadeloupe", "CountryCode": "GP", "DialNumber": "+590" },
        { "NID": "N-90", "Nationality": "Guam", "CountryCode": "GU", "DialNumber": "+1-671" },
        { "NID": "N-91", "Nationality": "Guatemala", "CountryCode": "GT", "DialNumber": "+502" },
        { "NID": "N-92", "Nationality": "Guernsey", "CountryCode": "GG", "DialNumber": "+44" },
        { "NID": "N-93", "Nationality": "Guinea", "CountryCode": "GN", "DialNumber": "+224" },
        { "NID": "N-94", "Nationality": "Guinea-Bissau", "CountryCode": "GW", "DialNumber": "+245" },
        { "NID": "N-95", "Nationality": "Guyana", "CountryCode": "GY", "DialNumber": "+592" },
        { "NID": "N-96", "Nationality": "Haiti", "CountryCode": "HT", "DialNumber": "+509" },
        { "NID": "N-97", "Nationality": "Heard Island and McDonald Islands", "CountryCode": "HM", "DialNumber": "+61" },
        { "NID": "N-98", "Nationality": "Holy See (Vatican City State)", "CountryCode": "VA", "DialNumber": "+39" },
        { "NID": "N-99", "Nationality": "Honduras", "CountryCode": "HN", "DialNumber": "+504" },
      { "NID": "N-100", "Nationality": "Hong Kong", "CountryCode": "HK", "DialNumber": "+852" },
        { "NID": "N-101", "Nationality": "Hungary", "CountryCode": "HU", "DialNumber": "+36" },
        { "NID": "N-102", "Nationality": "Iceland", "CountryCode": "IS", "DialNumber": "+354" },
        { "NID": "N-103", "Nationality": "India", "CountryCode": "IN", "DialNumber": "+91" },
        { "NID": "N-104", "Nationality": "Indonesia", "CountryCode": "ID", "DialNumber": "+62" },
        { "NID": "N-105", "Nationality": "Iran", "CountryCode": "IR", "DialNumber": "+98" },
        { "NID": "N-106", "Nationality": "Iraq", "CountryCode": "IQ", "DialNumber": "+964" },
        { "NID": "N-107", "Nationality": "Ireland", "CountryCode": "IE", "DialNumber": "+353" },
        { "NID": "N-108", "Nationality": "Isle of Man", "CountryCode": "IM", "DialNumber": "+44" },
        { "NID": "N-109", "Nationality": "Italy", "CountryCode": "IT", "DialNumber": "+39" },
        { "NID": "N-110", "Nationality": "Jamaica", "CountryCode": "JM", "DialNumber": "+1" },
        { "NID": "N-111", "Nationality": "Japan", "CountryCode": "JP", "DialNumber": "+81" },
        { "NID": "N-112", "Nationality": "Jersey", "CountryCode": "JE", "DialNumber": "+44" },
        { "NID": "N-113", "Nationality": "Jordan", "CountryCode": "JO", "DialNumber": "+962" },
        { "NID": "N-114", "Nationality": "Kazakhstan", "CountryCode": "KZ", "DialNumber": "+7" },
        { "NID": "N-115", "Nationality": "Kenya", "CountryCode": "KE", "DialNumber": "+254" },
        { "NID": "N-116", "Nationality": "Kiribati", "CountryCode": "KI", "DialNumber": "+686" },
        { "NID": "N-117", "Nationality": "Kosovo", "CountryCode": "XK", "DialNumber": "+383" },
        { "NID": "N-118", "Nationality": "Kuwait", "CountryCode": "KW", "DialNumber": "+965" },
        { "NID": "N-119", "Nationality": "Kyrgyzstan", "CountryCode": "KG", "DialNumber": "+996" },
        { "NID": "N-120", "Nationality": "Laos", "CountryCode": "LA", "DialNumber": "+856" },
        { "NID": "N-121", "Nationality": "Latvia", "CountryCode": "LV", "DialNumber": "+371" },
        { "NID": "N-122", "Nationality": "Lebanon", "CountryCode": "LB", "DialNumber": "+961" },
        { "NID": "N-123", "Nationality": "Lesotho", "CountryCode": "LS", "DialNumber": "+266" },
        { "NID": "N-124", "Nationality": "Liberia", "CountryCode": "LR", "DialNumber": "+231" },
        { "NID": "N-125", "Nationality": "Libya", "CountryCode": "LY", "DialNumber": "+218" },
        { "NID": "N-126", "Nationality": "Liechtenstein", "CountryCode": "LI", "DialNumber": "+423" },
        { "NID": "N-127", "Nationality": "Lithuania", "CountryCode": "LT", "DialNumber": "+370" },
        { "NID": "N-128", "Nationality": "Luxembourg", "CountryCode": "LU", "DialNumber": "+352" },
        { "NID": "N-129", "Nationality": "Macao", "CountryCode": "MO", "DialNumber": "+853" },
        { "NID": "N-130", "Nationality": "Macedonia", "CountryCode": "MK", "DialNumber": "+389" },
        { "NID": "N-131", "Nationality": "Madagascar", "CountryCode": "MG", "DialNumber": "+261" },
        { "NID": "N-132", "Nationality": "Malawi", "CountryCode": "MW", "DialNumber": "+265" },
        { "NID": "N-133", "Nationality": "Malaysia", "CountryCode": "MY", "DialNumber": "+60" },
        { "NID": "N-134", "Nationality": "Maldives", "CountryCode": "MV", "DialNumber": "+960" },
        { "NID": "N-135", "Nationality": "Mali", "CountryCode": "ML", "DialNumber": "+223" },
        { "NID": "N-136", "Nationality": "Malta", "CountryCode": "MT", "DialNumber": "+356" },
        { "NID": "N-137", "Nationality": "Marshall Islands", "CountryCode": "MH", "DialNumber": "+692" },
        { "NID": "N-138", "Nationality": "Martinique", "CountryCode": "MQ", "DialNumber": "+596" },
        { "NID": "N-139", "Nationality": "Mauritania", "CountryCode": "MR", "DialNumber": "+222" },
        { "NID": "N-140", "Nationality": "Mauritius", "CountryCode": "MU", "DialNumber": "+230" },
        { "NID": "N-141", "Nationality": "Mayotte", "CountryCode": "YT", "DialNumber": "+262" },
        { "NID": "N-142", "Nationality": "Mexico", "CountryCode": "MX", "DialNumber": "+52" },
        { "NID": "N-143", "Nationality": "Micronesia", "CountryCode": "FM", "DialNumber": "+691" },
        { "NID": "N-144", "Nationality": "Moldova", "CountryCode": "MD", "DialNumber": "+373" },
        { "NID": "N-145", "Nationality": "Monaco", "CountryCode": "MC", "DialNumber": "+377" },
        { "NID": "N-146", "Nationality": "Mongolia", "CountryCode": "MN", "DialNumber": "+976" },
        { "NID": "N-147", "Nationality": "Montenegro", "CountryCode": "ME", "DialNumber": "+382" },
        { "NID": "N-148", "Nationality": "Montserrat", "CountryCode": "MS", "DialNumber": "+1-664" },
        { "NID": "N-149", "Nationality": "Morocco", "CountryCode": "MA", "DialNumber": "+212" },
        { "NID": "N-150", "Nationality": "Mozambique", "CountryCode": "MZ", "DialNumber": "+258" },
        { "NID": "N-151", "Nationality": "Myanmar", "CountryCode": "MM", "DialNumber": "+95" },
        { "NID": "N-152", "Nationality": "Namibia", "CountryCode": "NA", "DialNumber": "+264" },
        { "NID": "N-153", "Nationality": "Nauru", "CountryCode": "NR", "DialNumber": "+674" },
        { "NID": "N-154", "Nationality": "Nepal", "CountryCode": "NP", "DialNumber": "+977" },
        { "NID": "N-155", "Nationality": "Netherlands", "CountryCode": "NL", "DialNumber": "+31" },
        { "NID": "N-156", "Nationality": "New Caledonia", "CountryCode": "NC", "DialNumber": "+687" },
        { "NID": "N-157", "Nationality": "New Zealand", "CountryCode": "NZ", "DialNumber": "+64" },
        { "NID": "N-158", "Nationality": "Nicaragua", "CountryCode": "NI", "DialNumber": "+505" },
        { "NID": "N-159", "Nationality": "Niger", "CountryCode": "NE", "DialNumber": "+227" },
        { "NID": "N-160", "Nationality": "Nigeria", "CountryCode": "NG", "DialNumber": "+234" },
        { "NID": "N-161", "Nationality": "Niue", "CountryCode": "NU", "DialNumber": "+683" },
        { "NID": "N-162", "Nationality": "Norfolk Island", "CountryCode": "NF", "DialNumber": "+672" },
        { "NID": "N-163", "Nationality": "North Korea", "CountryCode": "KP", "DialNumber": "+850" },
        { "NID": "N-164", "Nationality": "Northern Mariana Islands", "CountryCode": "MP", "DialNumber": "+1-670" },
        { "NID": "N-165", "Nationality": "Norway", "CountryCode": "NO", "DialNumber": "+47" },
        { "NID": "N-166", "Nationality": "Oman", "CountryCode": "OM", "DialNumber": "+968" },
        { "NID": "N-167", "Nationality": "Pakistan", "CountryCode": "PK", "DialNumber": "+92" },
        { "NID": "N-168", "Nationality": "Palau", "CountryCode": "PW", "DialNumber": "+680" },
        { "NID": "N-169", "Nationality": "Palestine", "CountryCode": "PS", "DialNumber": "+970" },
        { "NID": "N-170", "Nationality": "Panama", "CountryCode": "PA", "DialNumber": "+507" },
        { "NID": "N-171", "Nationality": "Papua New Guinea", "CountryCode": "PG", "DialNumber": "+675" },
        { "NID": "N-172", "Nationality": "Paraguay", "CountryCode": "PY", "DialNumber": "+595" },
        { "NID": "N-173", "Nationality": "Peru", "CountryCode": "PE", "DialNumber": "+51" },
        { "NID": "N-174", "Nationality": "Philippines", "CountryCode": "PH", "DialNumber": "+63" },
        { "NID": "N-175", "Nationality": "Pitcairn", "CountryCode": "PN", "DialNumber": "+64" },
        { "NID": "N-176", "Nationality": "Poland", "CountryCode": "PL", "DialNumber": "+48" },
        { "NID": "N-177", "Nationality": "Portugal", "CountryCode": "PT", "DialNumber": "+351" },
        { "NID": "N-178", "Nationality": "Puerto Rico", "CountryCode": "PR", "DialNumber": "+1-787" },
        { "NID": "N-179", "Nationality": "Qatar", "CountryCode": "QA", "DialNumber": "+974" },
        { "NID": "N-180", "Nationality": "Réunion", "CountryCode": "RE", "DialNumber": "+262" },
        { "NID": "N-181", "Nationality": "Romania", "CountryCode": "RO", "DialNumber": "+40" },
        { "NID": "N-182", "Nationality": "Russian Federation", "CountryCode": "RU", "DialNumber": "+7" },
        { "NID": "N-183", "Nationality": "Rwanda", "CountryCode": "RW", "DialNumber": "+250" },
        { "NID": "N-184", "Nationality": "Saint Barthélemy", "CountryCode": "BL", "DialNumber": "+590" },
        { "NID": "N-185", "Nationality": "Saint Helena, Ascension and Tristan da Cunha", "CountryCode": "SH", "DialNumber": "+290" },
        { "NID": "N-186", "Nationality": "Saint Kitts and Nevis", "CountryCode": "KN", "DialNumber": "+1-869" },
        { "NID": "N-187", "Nationality": "Saint Lucia", "CountryCode": "LC", "DialNumber": "+1-758" },
        { "NID": "N-188", "Nationality": "Saint Martin (French part)", "CountryCode": "MF", "DialNumber": "+590" },
        { "NID": "N-189", "Nationality": "Saint Pierre and Miquelon", "CountryCode": "PM", "DialNumber": "+508" },
        { "NID": "N-190", "Nationality": "Saint Vincent and the Grenadines", "CountryCode": "VC", "DialNumber": "+1-784" },
        { "NID": "N-191", "Nationality": "Samoa", "CountryCode": "WS", "DialNumber": "+685" },
        { "NID": "N-192", "Nationality": "San Marino", "CountryCode": "SM", "DialNumber": "+378" },
        { "NID": "N-193", "Nationality": "Sao Tome and Principe", "CountryCode": "ST", "DialNumber": "+239" },
        { "NID": "N-194", "Nationality": "Saudi Arabia", "CountryCode": "SA", "DialNumber": "+966" },
        { "NID": "N-195", "Nationality": "Senegal", "CountryCode": "SN", "DialNumber": "+221" },
        { "NID": "N-196", "Nationality": "Serbia", "CountryCode": "RS", "DialNumber": "+381" },
        { "NID": "N-197", "Nationality": "Seychelles", "CountryCode": "SC", "DialNumber": "+248" },
        { "NID": "N-198", "Nationality": "Sierra Leone", "CountryCode": "SL", "DialNumber": "+232" },
        { "NID": "N-199", "Nationality": "Singapore", "CountryCode": "SG", "DialNumber": "+65" },
      { "NID": "N-200", "Nationality": "Sint Maarten (Dutch part)", "CountryCode": "SX", "DialNumber": "+1-721" },
        { "NID": "N-201", "Nationality": "Slovakia", "CountryCode": "SK", "DialNumber": "+421" },
        { "NID": "N-202", "Nationality": "Slovenia", "CountryCode": "SI", "DialNumber": "+386" },
        { "NID": "N-203", "Nationality": "Solomon Islands", "CountryCode": "SB", "DialNumber": "+677" },
        { "NID": "N-204", "Nationality": "Somalia", "CountryCode": "SO", "DialNumber": "+252" },
        { "NID": "N-205", "Nationality": "South Africa", "CountryCode": "ZA", "DialNumber": "+27" },
        { "NID": "N-206", "Nationality": "South Georgia and the South Sandwich Islands", "CountryCode": "GS", "DialNumber": "+500" },
        { "NID": "N-207", "Nationality": "South Korea", "CountryCode": "KR", "DialNumber": "+82" },
        { "NID": "N-208", "Nationality": "South Sudan", "CountryCode": "SS", "DialNumber": "+211" },
        { "NID": "N-209", "Nationality": "Spain", "CountryCode": "ES", "DialNumber": "+34" },
        { "NID": "N-210", "Nationality": "Sri Lanka", "CountryCode": "LK", "DialNumber": "+94" },
        { "NID": "N-211", "Nationality": "Sudan", "CountryCode": "SD", "DialNumber": "+249" },
        { "NID": "N-212", "Nationality": "Suriname", "CountryCode": "SR", "DialNumber": "+597" },
        { "NID": "N-213", "Nationality": "Svalbard and Jan Mayen", "CountryCode": "SJ", "DialNumber": "+47" },
        { "NID": "N-214", "Nationality": "Swaziland", "CountryCode": "SZ", "DialNumber": "+268" },
        { "NID": "N-215", "Nationality": "Sweden", "CountryCode": "SE", "DialNumber": "+46" },
        { "NID": "N-249", "Nationality": "Switzerland", "CountryCode": "CH", "DialNumber": "+41" },
        { "NID": "N-216", "Nationality": "Syria", "CountryCode": "SY", "DialNumber": "+963" },
        { "NID": "N-217", "Nationality": "Taiwan, Province of China", "CountryCode": "TW", "DialNumber": "+886" },
        { "NID": "N-218", "Nationality": "Tajikistan", "CountryCode": "TJ", "DialNumber": "+992" },
        { "NID": "N-219", "Nationality": "Tanzania", "CountryCode": "TZ", "DialNumber": "+255" },
        { "NID": "N-220", "Nationality": "Thailand", "CountryCode": "TH", "DialNumber": "+66" },
        { "NID": "N-221", "Nationality": "Timor-Leste", "CountryCode": "TL", "DialNumber": "+670" },
        { "NID": "N-222", "Nationality": "Togo", "CountryCode": "TG", "DialNumber": "+228" },
        { "NID": "N-223", "Nationality": "Tokelau", "CountryCode": "TK", "DialNumber": "+690" },
        { "NID": "N-224", "Nationality": "Tonga", "CountryCode": "TO", "DialNumber": "+676" },
        { "NID": "N-225", "Nationality": "Trinidad and Tobago", "CountryCode": "TT", "DialNumber": "+1-868" },
        { "NID": "N-226", "Nationality": "Tunisia", "CountryCode": "TN", "DialNumber": "+216" },
        { "NID": "N-227", "Nationality": "Turkey", "CountryCode": "TR", "DialNumber": "+90" },
        { "NID": "N-228", "Nationality": "Turkmenistan", "CountryCode": "TM", "DialNumber": "+993" },
        { "NID": "N-229", "Nationality": "Turks and Caicos Islands", "CountryCode": "TC", "DialNumber": "+1-649" },
        { "NID": "N-230", "Nationality": "Tuvalu", "CountryCode": "TV", "DialNumber": "+688" },
        { "NID": "N-231", "Nationality": "Uganda", "CountryCode": "UG", "DialNumber": "+256" },
        { "NID": "N-232", "Nationality": "Ukraine", "CountryCode": "UA", "DialNumber": "+380" },
       
        { "NID": "N-234", "Nationality": "United Kingdom", "CountryCode": "GB", "DialNumber": "+44" },
        { "NID": "N-235", "Nationality": "United States", "CountryCode": "US", "DialNumber": "+1" },
        { "NID": "N-236", "Nationality": "United States Minor Outlying Islands", "CountryCode": "UM", "DialNumber": "+1-808" },
        { "NID": "N-237", "Nationality": "Uruguay", "CountryCode": "UY", "DialNumber": "+598" },
        { "NID": "N-238", "Nationality": "Uzbekistan", "CountryCode": "UZ", "DialNumber": "+998" },
        { "NID": "N-239", "Nationality": "Vanuatu", "CountryCode": "VU", "DialNumber": "+678" },
        { "NID": "N-240", "Nationality": "Venezuela", "CountryCode": "VE", "DialNumber": "+58" },
        { "NID": "N-241", "Nationality": "Vietnam", "CountryCode": "VN", "DialNumber": "+84" },
        { "NID": "N-242", "Nationality": "Virgin Islands, British", "CountryCode": "VG", "DialNumber": "+1-284" },
        { "NID": "N-243", "Nationality": "Virgin Islands, U.S.", "CountryCode": "VI", "DialNumber": "+1-340" },
        { "NID": "N-244", "Nationality": "Wallis and Futuna", "CountryCode": "WF", "DialNumber": "+681" },
        { "NID": "N-245", "Nationality": "Western Sahara", "CountryCode": "EH", "DialNumber": "+212" },
        { "NID": "N-246", "Nationality": "Yemen", "CountryCode": "YE", "DialNumber": "+967" },
        { "NID": "N-247", "Nationality": "Zambia", "CountryCode": "ZM", "DialNumber": "+260" },
        { "NID": "N-248", "Nationality": "Zimbabwe", "CountryCode": "ZW", "DialNumber": "+263" }



  ]


}
